/* Small accessibility enhancements around the native Impact interactions. */
document.addEventListener('click', (event) => {
  const link = event.target.closest('#header-sidebar-menu a');
  if (link) link.closest('navigation-drawer')?.hide?.();
});
